import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { Store } from '@ngxs/store';
import { map } from 'rxjs/operators';
import { AemGetAppConfig, AemGetMaintenance, AemGetMessages } from './shared/aem.action';
import { Router } from '@angular/router';
import { ActivatedRoute } from '@angular/router';
import { OffersComponent } from '../catalog/pages/offers/offers.component';

export * from './aem.module';
export * from './shared/aem.action';
export * from './shared/aem.guard';
export * from './shared/aem.model';
export * from './shared/aem.state';

@Injectable()
export class AemMessagesResolver  {
  constructor(public store: Store) {}

  resolve(route: ActivatedRouteSnapshot) {
    const path = 'content/myvf-business/configurations/messages.contents.json';

    return this.store.dispatch(new AemGetMessages(path)).pipe(map(() => true));
  }
}

@Injectable()
export class AemAppConfigResolver  {
  constructor(public store: Store) {}

  resolve(route: ActivatedRouteSnapshot) {
    const path = 'content/myvf-business/configurations/app-config.contents.json';

    return this.store.dispatch(new AemGetAppConfig(path)).pipe(map(() => true));
  }
}

@Injectable()
export class MaintenanceResolver  {
  constructor(public store: Store) {}

  resolve(route: ActivatedRouteSnapshot) {
    const path = 'content/myvf-business/configurations/maintenance.contents.json';

    return this.store.dispatch(new AemGetMaintenance(path))
      .pipe(
        map((res) => {
          console.log('Resolve {}', res);

          let maintenance: {flag: boolean, message?: string} = { flag: false }; // default is all enabled
          const deviceOs = res?.session?.device?.deviceOs ?? res?.session?.device?.appPlatform ?? 'android';

          // Compare Date
          res.aem?.partials?.forEach(part => {
            if(new Date().getTime()>=new Date(part.start).getTime()) {
              if(new Date().getTime()<=new Date(part.end).getTime()) {
                switch(route.routeConfig.path) {
                case 'offers.html': maintenance = {
                  flag: (part.pages?.includes('mobile_offers') && part.platforms?.includes(deviceOs)),
                  message: part.disabledMessage
                };
                  break;
                case 'active-offers.html': maintenance = {
                  flag: (part.pages?.includes('active_offers') && part.platforms?.includes(deviceOs)),
                  message: part.disabledMessage
                };
                  break;
                default: maintenance = { flag: false }; break;
                }
              }
            }
          });
          return maintenance;
        }));
  }

}

export function isInEditor(): boolean {
  const inIframe = window.self !== window.top;
  const haveAemCookie = document.cookie.indexOf('wcmmode') >= 0;
  return inIframe && haveAemCookie;
}
